<template>
        <div :class="['c-dropdown', classes]">
            <div class="c-dropdown__label" @click="toggle($event)">
                <span class="c-dropdown__label-text">
                    <font-awesome-icon icon="chevron-right" class="preicon"></font-awesome-icon>{{post.title.rendered}}
                </span>
                <span class="c-dropdown__label-toggle">
                    <font-awesome-icon icon="plus" class="c-dropdown__label-toggle-icon"></font-awesome-icon>
                </span>
            </div>

            <div class="c-dropdown__body" v-html="">
                <p v-html="post.excerpt.rendered"></p>
                <router-link :to="{ name: 'faqitem', params: { postSlug: post.slug }}" class="link">lees meer ...</router-link>

            </div>
        </div>
    </template>
<script>
    export default{
        props: ['post'],
        data () {
            return {
                isActive: false,
            }
        },
        computed: {
            classes () {
                return {
                    'is-active': this.isActive
                }
            }
        },
        methods: {
            open (e) {
                this.isActive = true;
            },

            close (e) {
                this.isActive = false;
            },

            toggle (e) {
                return (this.isActive ? this.close(e) : this.open(e));
            }

        },
    }
</script>